import { Component, OnInit } from "@angular/core";
import {
  AppSettings,
  enumStatusCodeList
} from "../../sharedcomponents/_common/constants/app.constants";
import { utilityService } from "../../sharedcomponents/commonservice/utility.service";
import { PayagainFailedorderService } from "../../_services/transaction/payagain-failedorder.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-payagain-failedorder",
  templateUrl: "./payagain-failedorder.component.html",
  styleUrls: ["./payagain-failedorder.component.css"]
})
export class PayagainFailedorderComponent implements OnInit {
  failedtranscationlist: any = [];
  orderProcessList: any = [];
  orderDetail: any;
  benificaryResponce: any;

  countofcart: number;
  totalamaount = 0;
  currencyCodeFrom;
  defaultOrderID;
  isSelect: boolean;
  constructor(
    public utilserv: utilityService,
    private router: Router,
    public payeagainservice: PayagainFailedorderService
  ) {
    const unsubpayeagainservice = this.payeagainservice
      .getfailtransbenifcaryDetailData()
      .subscribe(
        data => {
          this.orderDetail = data;
          const failTrasArray = this.utilserv.getArray(data);
          this.defaultOrderID = this.utilserv.getObjectText(
            failTrasArray[0].OrderNumber
          );
          //    this.currencyCodeFrom = this.utilserv.getObjectText(failTrasArray[0].CurrencyCodeFrom);

          this.countofcart = failTrasArray.length;

          if (unsubpayeagainservice != undefined) {
            unsubpayeagainservice.unsubscribe();
          }
        },
        error => {}
      );
  }

  ngOnInit() {
    if (this.orderDetail == undefined) {
      this.router.navigate(["transactionlist"]);
      return false;
    }
    this.getfailedtranslist(this.orderDetail);
  }

  // registerCheckBox(element){
  //   if(element.id ===  this.defaultOrderID){
  //     const selectedelement = <HTMLInputElement> document.getElementById(this.defaultOrderID);

  //   }
  // }

  getfailedtranslist(failedOrderDetail) {
    //try{
    this.utilserv.busy = this.payeagainservice
      .getfailedtransactionlistservice(failedOrderDetail)
      .subscribe(
        data => {
          const response = data.Envelope.Body.OutGoingTransactionResponse;
          if (response.StatusCode == enumStatusCodeList.SUCCESS) {
            // this.benificaryResponce = response.BeneficiaryTransactions.BeneficiaryTransaction;
            //  this.failedtranscationlist
            // .Orders.OrderDetail

            const benificaryOrderDetail = this.utilserv.getArray(
              response.BeneficiaryTransactions.BeneficiaryTransaction
            );
            benificaryOrderDetail.forEach(element => {
              const orderInfo = this.utilserv.getArray(
                element.Orders.OrderDetail
              );
              orderInfo.forEach(orderElement => {
                const indBenificary: any = {};
                indBenificary.NickName = this.utilserv.getObjectText(
                  element.Beneficiary.NickName
                );
                indBenificary.FirstName = this.utilserv.getObjectText(
                  element.Beneficiary.FirstName
                );
                indBenificary.LastName = this.utilserv.getObjectText(
                  element.Beneficiary.LastName
                );
                indBenificary.AdditionalLastName = this.utilserv.getObjectText(
                  element.Beneficiary.AdditionalLastName
                );
                indBenificary.TotalAmount = this.utilserv.getObjectText(
                  orderElement.TotalAmount
                );
                indBenificary.CurrencyCodeFrom = this.utilserv.getObjectText(
                  orderElement.CurrencyCodeFrom
                );
                indBenificary.OrderNumber = this.utilserv.getObjectText(
                  orderElement.OrderNumber
                );
                if (this.defaultOrderID == orderElement.OrderNumber) {
                  indBenificary.checked = true;
                  this.manageorderDetail(orderElement);
                } else {
                  indBenificary.checked = false;
                }

                this.failedtranscationlist.push(indBenificary);

                indBenificary.OrderDetail = orderElement; // this.utilserv.getArray(element.Orders.OrderDetail);
              });
            });

            // this.utilserv.getArray(response.BeneficiaryTransactions.BeneficiaryTransaction.Orders);

            // this.failedtranscationlist.forEach(element => {
            //                                     if( this.defaultOrderID == element.OrderNumber){
            //                                       element.checked = true;
            //                                         this.manageorderDetail(element);
            //                                     }else{
            //                                       element.checked = false;
            //                                     }
            //                                   });
          } else {
          }
        },
        error => {
          // alert(error);
          //this.router.navigate(['splashscreen'])
        }
      );
    // }catch(ex){
    //   console.log(ex);
    // }
  }

  continueTrans() {
    this.router.navigate(["/transdebitcard"]);
    return;
  }
  manageorderDetail(orderInfo) {
    const element = this.utilserv.getObjectText(orderInfo.OrderNumber);
    if (this.orderProcessList.length > 0) {
      const indexofElement = this.orderProcessList.indexOf(element);
      if (indexofElement !== -1) {
        this.orderProcessList.splice(indexofElement, 1);
        this.totalamaount -= Number(
          this.utilserv.getObjectText(orderInfo.TotalAmount)
        );
      } else {
        this.totalamaount += Number(
          this.utilserv.getObjectText(orderInfo.TotalAmount)
        );
        this.orderProcessList.push(element);
      }
    } else {
      this.totalamaount += Number(
        this.utilserv.getObjectText(orderInfo.TotalAmount)
      );
      this.orderProcessList.push(element);
    }
    if (this.orderProcessList.length > 0) {
      const repayModel = new RepayModel();
      repayModel.orderList = this.orderProcessList;
      repayModel.totalAmount = this.totalamaount;
      this.payeagainservice.setrepaytransbenifcaryDetailData(repayModel);
    }
  }
}
class RepayModel {
  orderList: any = [];
  totalAmount = 0;
}



// WEBPACK FOOTER //
// ./src/app/transaction-history/payagain-failedorder/payagain-failedorder.component.ts